export const urlSiemprePago = `${process.env.REACT_APP_PAY_GATE_SIEMPREPAGO_LIB}?key=${process.env.REACT_APP_SIEMPRE_PAGO_API_KEY}`;
export const urlBancard = `${process.env.REACT_APP_PAY_GATE_BANCARD_LIB}`;

export const maxBancardAttempts = 10;
export const maxAtcAttempts = 10;
export const maxWompiAttempts = 10;
export const maxDLocalAttempts = 20;
export const dLocalPollIntervalMs = 10_000;

export const branchOfficeIdDLocalIdProduction = 204;
export const branchOfficeIdDLocalIdTesting = 95;
